import React, { useState } from 'react'
import { OverlayTrigger, Tooltip, Button, Spinner } from 'react-bootstrap'

const ExportButton = ({ callback, onError }) => {
  const [loading, setLoading] = useState(false);

  const clickHandler = () => {
    setLoading(true);

    callback()
      .catch(onError)
      .then(() => setLoading(false));
  }

   return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Exportar a Excel</strong>
        </Tooltip>
      }
    >
      <Button variant="primary" onClick={clickHandler} disabled={loading}>
        {loading 
          ? <><Spinner size="sm" className="align-middle mr-1" animation="border" variant="light" /> Generando</>
          : <>Generar</>} Reporte
      </Button>
    </OverlayTrigger>
  )
}

export default ExportButton